export const getStyles = (lgDown: boolean) => {
    const styles = {
        addQuestionButton: {
            color: '#F1594E', 
            textTransform: 'none', 
            fontSize: '18px',
        },
        createButton: { 
            borderRadius: '10px', 
            color: '#FFFFFF',
            fontWeight: 600,
            backgroundColor: '#F1594E',
            textTransform: 'none',
            '&:hover':{
                backgroundColor: '#d85046'
            } 
        },
        cancelButton: {
            borderRadius: '10px', 
            color: '#F1594E',
            fontWeight: 600,
            borderColor: '#F1594E',
            textTransform: 'none',
            '&:hover':{
                borderColor: '#d85046'
            } 
        },
        backDrop: { 
            color: '#fff', 
            zIndex: 100, 
            ml: lgDown? 0 : '350px' 
        },
    };
    return styles;
};